import { Box, Divider, Stack, Typography, type TypographyProps } from "@mui/material";
import type { Field, FieldIdToValueMap } from "../../api/types/objectTypes";
import { formatNumericValue, withRecordCurrency } from "./helpers";

interface SummaryRowProps {
  label: string;
  field: Field;
  value: unknown;
  fieldValues: FieldIdToValueMap;
  variant?: TypographyProps["variant"];
  valueColor?: TypographyProps["color"];
}

const SummaryRow = ({ label, field, value, fieldValues, variant, valueColor }: SummaryRowProps) => (
  <Box sx={{ display: "flex", justifyContent: "space-between", gap: 3 }}>
    <Typography variant={variant} color="textSecondary">
      {label}
    </Typography>
    <Typography variant={variant} color={valueColor}>
      {typeof value === "number" && !Number.isNaN(value)
        ? formatNumericValue(value, withRecordCurrency(field.configuration, fieldValues))
        : ""}
    </Typography>
  </Box>
);

interface Props {
  fields: Field[];
  fieldValues: FieldIdToValueMap;
  difference?: Pick<SummaryRowProps, "label" | "field" | "value">;
}

const RelatedObjectsSummary = ({ fields, fieldValues, difference }: Props) => (
  <Stack spacing={0.5} sx={{ minWidth: 320 }}>
    {fields.map((field, index) => (
      <SummaryRow
        key={field.id}
        label={field.name}
        field={field}
        value={fieldValues[field.id]}
        fieldValues={fieldValues}
        variant={index === fields.length - 1 ? "subtitle1" : undefined}
      />
    ))}
    {difference && (
      <>
        {fields.length > 0 && <Divider sx={{ borderStyle: "dashed" }} />}
        <SummaryRow {...difference} fieldValues={fieldValues} valueColor="warning" />
      </>
    )}
  </Stack>
);

export default RelatedObjectsSummary;
